module.exports = __webpack_public_path__ + "static/media/Tesla.456f380b.jpg";